module.exports = __webpack_public_path__ + "img/2.25795d32.png";